module.exports = function (endpoint, q, cb) {
    var endpointUrl = URI(endpoint);

    if (q) {
        endpointUrl.setQuery('q', q);
    }
    else {
        endpointUrl.removeQuery('q');
    }

    $.ajax({
        url: endpointUrl.toString(),
        success: function (result) {
            if (cb) {
                cb(result);
            }
        },
        error: function (xhr, status, error) {
            return { 'error': error };
        }
    });
};